export const environment = {
  production: false,
  baseURL: 'https://api.el-bershama.com/',
  projectName: 'Al-Bershama',
  version: '0.0.4',
};
